import { render, staticRenderFns } from "./SectionTicketsInQueue.vue?vue&type=template&id=afaf3a88&scoped=true&"
import script from "./SectionTicketsInQueue.vue?vue&type=script&lang=js&"
export * from "./SectionTicketsInQueue.vue?vue&type=script&lang=js&"
import style0 from "./SectionTicketsInQueue.vue?vue&type=style&index=0&id=afaf3a88&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afaf3a88",
  null
  
)

export default component.exports